import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _createSuper from "@babel/runtime/helpers/esm/createSuper";
import React, { Component } from 'react';
import ClickOutside from '../click-outside';
import ButtonItem from './widgets/button-item';

var InsertTable = /*#__PURE__*/function (_Component) {
  _inherits(InsertTable, _Component);

  var _super = _createSuper(InsertTable);

  function InsertTable(props) {
    var _this;

    _classCallCheck(this, InsertTable);

    _this = _super.call(this, props);

    _this.toggleCard = function () {
      _this.setState({
        showCard: !_this.state.showCard,
        columnCount: -1,
        rowCount: -1
      });
    };

    _this.createTableCells = function () {
      var rows = [];
      var _this$state = _this.state,
          columnCount = _this$state.columnCount,
          rowCount = _this$state.rowCount,
          currentMaxColumnCount = _this$state.currentMaxColumnCount,
          currentMaxRowCount = _this$state.currentMaxRowCount;

      var _loop = function _loop(rowIndex) {
        var cells = [];

        var _loop2 = function _loop2(columnIndex) {
          var isActive = columnIndex <= columnCount - 1 && rowIndex <= rowCount - 1;
          var vDom = /*#__PURE__*/React.createElement("div", {
            onMouseEnter: function onMouseEnter() {
              return _this.onTableCellMouseEnter(rowIndex, columnIndex);
            },
            key: "table-row-".concat(rowIndex, "-").concat(columnIndex),
            className: "sf-editor-table-card-cell ".concat(isActive ? 'sf-editor-table-card-active-cell' : '')
          });
          cells.push(vDom);
        };

        for (var columnIndex = 0; columnIndex < currentMaxColumnCount; columnIndex++) {
          _loop2(columnIndex);
        }

        var row = /*#__PURE__*/React.createElement("div", {
          key: "table-row-".concat(rowIndex),
          className: "sf-editor-table-card-row"
        }, cells);
        rows.push(row);
      };

      for (var rowIndex = 0; rowIndex < currentMaxRowCount; rowIndex++) {
        _loop(rowIndex);
      }

      return /*#__PURE__*/React.createElement("div", {
        onClick: function onClick(event) {
          return _this.onAddTable(event, rowCount, columnCount);
        },
        className: "sf-editor-table-card"
      }, rows);
    };

    _this.onAddTable = function (event, rowCount, columnCount) {
      _this.props.onAddTable(event, rowCount, columnCount);

      _this.toggleCard();
    };

    _this.onTableCellMouseEnter = function (rowIndex, columnIndex) {
      var columnCount = columnIndex + 1,
          rowCount = rowIndex + 1;
      var currentMaxRowCount = rowCount + 1,
          currentMaxColumnCount = columnCount + 1;

      if (currentMaxColumnCount > 10) {
        currentMaxColumnCount = 10;
      } else if (currentMaxColumnCount < 4) {
        currentMaxColumnCount = 4;
      }

      if (currentMaxRowCount > 10) {
        currentMaxRowCount = 10;
      } else if (currentMaxRowCount < 4) {
        currentMaxRowCount = 4;
      }

      _this.setState({
        columnCount: columnCount,
        rowCount: rowCount,
        currentMaxColumnCount: currentMaxColumnCount,
        currentMaxRowCount: currentMaxRowCount
      });
    };

    _this.state = {
      showCard: false,
      currentMaxColumnCount: 4,
      currentMaxRowCount: 4,
      columnCount: -1,
      rowCount: -1
    };
    return _this;
  }

  _createClass(InsertTable, [{
    key: "createTableScaleCard",
    value: function createTableScaleCard(props) {
      var _this$state2 = this.state,
          columnCount = _this$state2.columnCount,
          rowCount = _this$state2.rowCount;
      return /*#__PURE__*/React.createElement("div", {
        className: "sf-editor-table-count-card"
      }, /*#__PURE__*/React.createElement("div", {
        className: "sf-editor-table-cells-header"
      }, "".concat(columnCount < 0 ? 0 : columnCount, " x ").concat(rowCount < 0 ? 0 : rowCount)), this.createTableCells());
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          disabled = _this$props.disabled,
          isRichEditor = _this$props.isRichEditor,
          text = _this$props.text;
      var showCard = this.state.showCard;
      return /*#__PURE__*/React.createElement("div", {
        className: "sf-editor-table-btn-wrapper"
      }, /*#__PURE__*/React.createElement(ButtonItem, {
        disabled: disabled,
        isRichEditor: isRichEditor,
        text: text,
        id: 'tableButton',
        icon: 'iconfont icon-table',
        onMouseDown: this.toggleCard
      }), showCard && /*#__PURE__*/React.createElement(ClickOutside, {
        clickOutside: this.toggleCard
      }, this.createTableScaleCard()));
    }
  }]);

  return InsertTable;
}(Component);

export default InsertTable;